import Grid from '@material-ui/core/Grid'
import React from 'react'
import useValidation from '../../../hooks/Validation/useValidation'
import { ROUTES } from '../../../shared/constants'
import ActionButton from '../../ActionButton'
import CustomInput from '../../CustomInput'
import CustomSelect from '../../CustomSelect'
import ImageInputField from '../../ImageInputField'

export default function EmployeeFormStep4({ kycDetails, setKycDetails, addKyc }) {
  const { handleValidation, error, handleValidationPAN, errorPAN } = useValidation()

  const { panCard, aadharCard, bankDetails, bankName, bankBranch, accountNumber, ifsc, cancelledCheque } = kycDetails
  const inputValues = [
    {
      label: 'PAN',
      value: panCard,
      name: 'panCard',
    },
    { label: 'AADHAR', value: aadharCard, name: 'aadharCard' },
    { label: 'BANK NAME', value: bankName, name: 'bankName' },
    // { label: 'Last Name *' },
    { label: 'BANK BRANCH', value: bankBranch, name: 'bankBranch' },
    // { date: <CustomDatePicker date={dob} setDate={setDob} label="DOB *" /> },
    { label: 'ACCOUNT NUMBER', value: accountNumber, name: 'accountNumber' },
    { label: 'IFSC', value: ifsc, name: 'ifsc' },
    // { label: 'CANCELLED CHEQUE', value: cancelledCheque, name: 'cancelledCheque', type : "IMAGE", s3upload :true },
    // { label: 'Reporting Time *', value: reportingTime, name: setReportingTime },
  ]

  return (
    <Grid container>
      {inputValues.map((item, index) => (
        <Grid item lg={4} key={index}>
          {item.select ? (
            <CustomSelect label={item.label} options={item.options} value={item.value} name={item.name} />
          ) : item.date ? (
            item.date
          ) : (
            <div style={{ marginTop: '10px' }}>
              <CustomInput
                label={item.label}
                icon={item.icon}
                name={item.name}
                value={item.value}
                number={item.number ? true : false}
                form={kycDetails}
                setForm={setKycDetails}
                formCheck={true}
              />
            </div>
          )}
        </Grid>
      ))}
      <Grid item lg={12}>
        <ImageInputField
          label={"Cancelled Cheque"}
          name={"cancelledCheque"}
          form={kycDetails}
          setForm={setKycDetails}
          multiple={true}
          s3upload = {true}
          noOfFiles = {2}
          // limit={limit}
          // accept={item.accept}
          // restriction={item.restriction}
          // limit={item.limit}
        />
      </Grid>
    </Grid>
  )
}
